import { render, staticRenderFns } from "./ScreenshotTabsSection.vue?vue&type=template&id=949e6f54"
import script from "./ScreenshotTabsSection.vue?vue&type=script&lang=js"
export * from "./ScreenshotTabsSection.vue?vue&type=script&lang=js"
import style0 from "./ScreenshotTabsSection.vue?vue&type=style&index=0&id=949e6f54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports